exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asset-preview:hover .card-body .asset-info.stay[data-v-03d53d0c]{opacity:1}.asset-preview .title[data-v-03d53d0c]{overflow-wrap:anywhere}", ""]);

// exports
